import {Reason} from './reason'

export default Reason